(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-float"] && !Shopify.designMode) return;
  try {
    jQuery(document).ready(function ($) {
    const $float = $('.pdp-buyflow__float');
    const $actions = $('.product__actions .action--atc button');

    function checkVisibility() {
      if ($actions.length === 0) return; // safety check

      const windowTop = $(window).scrollTop();
      const actionsBottom = $actions.offset().top + $actions.outerHeight();

      // show only when product__actions has scrolled up off the page
      if (actionsBottom < windowTop) {
        $float.addClass('is-active');
      } else {
        $float.removeClass('is-active');
      }
    }

    // run on scroll and resize
    $(window).on('scroll resize', checkVisibility);
    checkVisibility();

    $('.pdp-buyflow__float .btn--atc').on('click', function () {
      $('#product-form .product__actions .action--atc button').click();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
